import React from "react";
import {
  Phone,
  EnvelopeSimple,
  WhatsappLogo,
  MapPin,
  ArrowUpRight,
} from "@phosphor-icons/react";
import {
  FacebookCircleIcon,
  InstagramCircleIcon,
  LinkedinCircleIcon,
  TikTokCircleIcon,
} from "../Icon";

export const contactData = {
  mobile: ["9851051663", "01-5918663", "01-5917663"],
  email: "clamphook.academy@gmail.com",
  // Must match the Google Business Profile and localBusinessLd() exactly.
  address: "Thapathali, Kathmandu, Nepal",
  mapUrl: "https://maps.google.com/?cid=5174917909678823465",
  whatsapp: "9779851051663",
};

const focusCls =
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-inset";

const rowCls =
  "flex items-center gap-3 px-4 min-h-[56px] py-2 text-sm font-medium text-gray-800 dark:text-gray-200 no-underline hover:bg-gray-50 dark:hover:bg-gray-700/40 transition-colors";

const Label = ({ children }: { children: React.ReactNode }) => (
  <p className="px-4 pt-4 pb-1 text-sm font-semibold text-gray-900 dark:text-gray-100">{children}</p>
);

const socials = [
  { href: "https://www.facebook.com/clamphookioe", label: "Facebook", Icon: FacebookCircleIcon },
  { href: "https://www.linkedin.com/company/clamphookioe/", label: "LinkedIn", Icon: LinkedinCircleIcon },
  { href: "https://www.instagram.com/clamphook", label: "Instagram", Icon: InstagramCircleIcon },
  { href: "https://www.tiktok.com/@clamphook_", label: "TikTok", Icon: TikTokCircleIcon },
];

const ContactInformation = () => {
  return (
    <section
      aria-label="Contact details"
      className="w-full rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 divide-y divide-gray-100 dark:divide-gray-700 overflow-hidden"
    >
      {/* Fastest ways to reach us come first, large enough to tap */}
      <div>
        <Label>Talk to us</Label>
        <a
          href={`https://wa.me/${contactData.whatsapp}`}
          target="_blank"
          rel="noopener noreferrer"
          className={`${rowCls} ${focusCls}`}
        >
          <WhatsappLogo size={20} weight="fill" aria-hidden className="text-green-600 dark:text-green-400 shrink-0" />
          <span className="flex-1">WhatsApp {contactData.mobile[0]}</span>
          <ArrowUpRight size={14} aria-hidden className="text-gray-500" />
        </a>
        {contactData.mobile.map((num) => (
          <a key={num} href={`tel:${num}`} className={`${rowCls} ${focusCls}`}>
            <Phone size={20} weight="fill" aria-hidden className="text-primary dark:text-primary-300 shrink-0" />
            <span className="flex-1 tabular-nums">{num}</span>
          </a>
        ))}
        <a href={`mailto:${contactData.email}`} className={`${rowCls} ${focusCls} pb-2`}>
          <EnvelopeSimple size={20} weight="fill" aria-hidden className="text-primary dark:text-primary-300 shrink-0" />
          <span className="flex-1 break-all">{contactData.email}</span>
        </a>
      </div>

      <div>
        <Label>Kathmandu classroom</Label>
        <address className="not-italic px-4 pb-1 flex items-start gap-3 text-sm text-gray-700 dark:text-gray-300">
          <MapPin size={20} weight="fill" aria-hidden className="text-primary dark:text-primary-300 shrink-0 mt-0.5" />
          <span>
            Clamphook Academy
            <br />
            {contactData.address}
          </span>
        </address>
        <a
          href={contactData.mapUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={`${rowCls} ${focusCls} text-primary-700 dark:text-primary-300 font-semibold`}
        >
          <span className="flex-1 pl-8">Get directions</span>
          <ArrowUpRight size={14} aria-hidden />
        </a>
      </div>

      <div className="px-4 py-3">
        <p className="text-sm font-semibold text-gray-900 dark:text-gray-100 mb-1">Follow us</p>
        <div className="flex">
          {socials.map(({ href, label, Icon }) => (
            <a
              key={label}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={label}
              className="-ml-1 first:ml-0 w-12 h-12 grid place-items-center rounded-xl opacity-80 hover:opacity-100 transition-opacity focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
            >
              <Icon />
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ContactInformation;
